import moment from "moment";

const dateFormat = (fmt, date) => {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    's+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      );
    }
  }
  return fmt;
}

const timeFormat = (time) => {
  if (time) {
    let res = moment(time).format("YYYY-MM-DD HH:mm:ss");
    return res;
  } else {
    return ''
  }
}

const timeFormatMmd = (time) => {
  if (time) {
    let res = moment(time).format("YYYY-MM-DD");
    return res;
  } else {
    return ''
  }
}

const timeFormatMmdTime = (time) => {
  if (time) {
    let res = moment(time).format("HH:mm:ss");
    return res;
  } else {
    return ''
  }
}


/*
* @name: 过滤器 转换金额
* @description:
* @author: KING
* @time: 2022-09-29 14:58:43
*/
const NumFormat = (value) => {
  if (!['[object Number]', '[object String]'].includes(Object.prototype.toString.call(value))) {
    return value
  }
  let num = value.toString().replace(/^(\d+)(\.\d+)?$/g, (big, ...args) => {
    let [a, b] = args
    if (!b) b = '.'
    while (b.length <= 2) {
      b += '0'
    }
    return a + b
  })
  return num;
}

export default {dateFormat, timeFormat, timeFormatMmd, timeFormatMmdTime, NumFormat};
